var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoadingFeatures)?_c('div',{staticClass:"template-library-wrapper"},[_c(_vm.templateLibraryComponent,{directives:[{name:"aha-emit-action",rawName:"v-aha-emit-action.view",modifiers:{"view":true}}],tag:"component"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }